import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasMenuPerm } from "../lib/menuAcl";

const ADMIN_TIER = ["admin", "super_admin"];
const STAFF_TIER = ["admin", "super_admin", "staff", "editor"];
const PURE_STAFF = ["staff", "editor"];

export default function ProtectedRoute({ children, adminOnly = false, allowedRoles, menu }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-neutral-500">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  let allowed = allowedRoles;
  if (adminOnly && !allowed) allowed = ADMIN_TIER;
  if (allowed) {
    const expanded = allowed.flatMap((r) =>
      r === "admin_tier" ? ADMIN_TIER :
      r === "staff_tier" ? STAFF_TIER : [r]
    );
    if (!expanded.includes(user.role)) {
      // Route to a role-appropriate safe landing so we never bounce into
      // an infinite navigate loop (see iter-22 RootGate fix).
      if (PURE_STAFF.includes(user.role)) {
        return <Navigate to="/admin/bookings" replace />;
      }
      return <Navigate to="/" replace />;
    }
  }
  // v4.6.8 — granular menu gate: no `view` on this screen ⇒ clean redirect
  // to the dashboard instead of a blank, permission-denied page.
  if (menu && !hasMenuPerm(user, menu, "view")) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
